import { Box } from "@mui/material"
import React from "react"

const SIZE = 56
const SPOKE_COUNT = 12

const SPOKE_TOP = 8.33
const SPOKE_HEIGHT = 25
const PIVOT = ((50 - SPOKE_TOP) / SPOKE_HEIGHT) * 100

export function CallSpinner() {
  return (
    <Box
      role="progressbar"
      aria-label="Loading"
      sx={{
        position: "relative",
        width: SIZE,
        height: SIZE,
        animation: "call-spinner-rotate 1s steps(12) infinite",
        "@keyframes call-spinner-rotate": {
          to: { transform: "rotate(360deg)" },
        },
      }}
    >
      {Array.from({ length: SPOKE_COUNT }, (_, index) => (
        <Box
          key={index}
          sx={{
            position: "absolute",
            top: `${SPOKE_TOP}%`,
            left: "45.83%",
            width: "8.33%",
            height: `${SPOKE_HEIGHT}%`,
            borderRadius: "5px",
            backgroundColor: "var(--color-foreground-fg-white)",
            opacity: 1 - index / SPOKE_COUNT,
            transformOrigin: `50% ${PIVOT}%`,
            transform: `rotate(${index * (360 / SPOKE_COUNT)}deg)`,
          }}
        />
      ))}
    </Box>
  )
}
